
import { Component, Vue } from "vue-property-decorator";

@Component
export class PRow extends Vue {}
export default PRow;
